import { createVersionedComponentLoader } from '../../../../VersionedComponentLoader';
import { VersionedContext, VersionedComponents } from '../../../../constants';
const MessagesPreviewList = ({ version, i18n, service }) =>
  createVersionedComponentLoader(
    VersionedContext.PREVIEW,
    VersionedComponents.MESSAGES_PREVIEW_LIST
  )(version)({
    i18n,
    service
  });
export default MessagesPreviewList;
